export const APImportTemplateForm = [
  {
    header: {
      header: 'DocDate',
      width: 17,
    },
    dataType: 'date',
  },
  {
    header: {
      header: 'TransactionDate',
      width: 17,
    },
    dataType: 'date',
  },
  {
    header: {
      header: 'DocNo',
      width: 17,
    },
  },
  {
    header: {
      header: 'RefNo',
      width: 17,
    },
  },
  {
    header: {
      header: 'Description',
      width: 40,
    },
  },
  {
    header: {
      header: 'CreditorName',
      width: 30,
    },
  },
  {
    header: {
      header: 'HeaderRemark',
      width: 30,
    },
  },
  {
    header: {
      header: 'ItemName',
      width: 17,
    },
  },
  {
    header: {
      header: 'DepartmentCode',
      width: 17,
    },
  },
  {
    header: {
      header: 'UOMCode',
      width: 17,
    },
  },
  {
    header: {
      header: 'TaxSchemeName',
      width: 17,
    },
  },
  {
    header: {
      header: 'Quantity',
      width: 15,
    },
    dataType: 'amount',
  },
  {
    header: {
      header: 'UnitPrice',
      width: 15,
    },
    dataType: 'amount',
  },
  {
    header: {
      header: 'ItemRemark',
      width: 40,
    },
  },
]
